export default {
  methods: {
    compare (names = [], errors, msg = 'Пароли не совпадают. ') {
      let prev = null
      for (let i = 0; i < names.length; i++) {
        let name = names[i]
        if (!prev) {
          prev = this.fields[name]
        } else {
          if (prev !== this.fields[name]) {
            errors[name] = (errors[name] || '') + msg
            break
          }
          prev = this.fields[name]
        }
      }
    },
    minLen (names = [], errors, len = 8) {
      names.forEach(name => {
        if (this.fields[name].length < len) {
          errors[name] = (errors[name] || '') + 'Минимальная длина ' + len + ' символов. '
        }
      })
    },
    checkRegExp (names = [], errors, condition, msg) {
      names.forEach(name => {
        let regExp = new RegExp(condition)
        if (!regExp.test(this.fields[name])) {
          errors[name] = (errors[name] || '') + msg
        }
      })
    }
  }
}
